/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ModuleConfigCreate } from '../models/ModuleConfigCreate';
import type { ModuleConfigDetails } from '../models/ModuleConfigDetails';
import type { ModuleConfigUpdate } from '../models/ModuleConfigUpdate';
import { request as __request } from '../core/request';

export class ModuleConfigsVService {

    /**
     * @param configId
     * @param districtId
     * @param requestBody
     * @returns ModuleConfigDetails OK
     * @throws ApiError
     */
    public static async moduleConfigsVUpdateDistrict(
        configId: string,
        districtId: string,
        requestBody?: ModuleConfigUpdate,
    ): Promise<ModuleConfigDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/districts/${districtId}/module-config/${configId}`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param districtId
     * @returns ModuleConfigDetails OK
     * @throws ApiError
     */
    public static async moduleConfigsVGetDistrictModuleConfig(
        districtId: string,
    ): Promise<ModuleConfigDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/districts/${districtId}/module-config`,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param districtId
     * @param requestBody
     * @returns ModuleConfigDetails Created
     * @throws ApiError
     */
    public static async moduleConfigsVCreate(
        districtId: string,
        requestBody?: ModuleConfigCreate,
    ): Promise<ModuleConfigDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/districts/${districtId}/module-config`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

}